import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, DescriptiveText, Page, Row, Tile} from '../../../../../shared';
import history from '../../../../../history';
import {_openModal} from '../../../../../shared/reducers/modals';

const SalesForceConnectIndividual = (props) => {
  const {session} = props;

  return <Page>
    <Tile key='Salesforce' title='Salesforce'>
      <DescriptiveText>
        If you have a Salesforce Financial Services account you can connect it to access your Salesforce platform from right
        within {session.profile.brand.advisorPlatformName}. You just have to sign in once and it will remain connected.
      </DescriptiveText>
      <Row>
        <Button importance={'primary'} size={'md'} label={'Cancel'} action={() => history.push('/integrations')}/>
        <Button importance={'primary'}
                size={'md'}
                label={'Sign In'}
                action={() => history.push('/engage/sfs/connect/individual')}/>
      </Row>
    </Tile>
  </Page>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});
export default connect(mapStateToProps, mapDispatchToProps)(SalesForceConnectIndividual);

SalesForceConnectIndividual.propTypes = {
  /**
   * Is from Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.object}).isRequired,
  /**
   * The open modal function to dispatch _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
};
